import { shouldHideAppChrome } from "@/utils/embed";
import {
  destroyActiveGuide,
  getGuideIdForRoute,
  startFeatureGuide,
} from "@/utils/featureGuide";
import { GUIDE_IDS } from "@/config/featureGuides";

export default {
  computed: {
    featureGuideId() {
      return this.ebkFeatureGuideId || null;
    },
    featureGuideEmbedMode() {
      return shouldHideAppChrome();
    },
    featureGuideCanMaintain() {
      if (typeof this.canMaintainHotel === "boolean") {
        return this.canMaintainHotel;
      }
      const u = this.userInfo || {};
      if (
        u.can_maintain_hotel !== undefined &&
        u.can_maintain_hotel !== null &&
        u.can_maintain_hotel !== ""
      ) {
        return Number(u.can_maintain_hotel) === 1;
      }
      return Number(u.zhilian_type) === 3;
    },
  },
  mounted() {
    var self = this;
    this._ebkOnShellGuide = function (payload) {
      payload = payload || {};
      var wantId = payload.guideId;
      if (!wantId) {
        wantId = getGuideIdForRoute(self.$route && self.$route.path);
      }
      if (wantId && wantId === self.featureGuideId) {
        self.startPageGuide(true);
      }
    };
    this.$root.$on("ebk-start-feature-guide", this._ebkOnShellGuide);
  },
  deactivated() {
    destroyActiveGuide();
  },
  beforeDestroy() {
    destroyActiveGuide();
    if (this._ebkOnShellGuide) {
      this.$root.$off("ebk-start-feature-guide", this._ebkOnShellGuide);
    }
  },
  beforeRouteLeave(to, from, next) {
    destroyActiveGuide();
    next();
  },
  methods: {
    startPageGuide(manual) {
      if (!this.featureGuideId) return null;
      return startFeatureGuide(this.featureGuideId, {
        ctx: this,
        manual: manual !== false,
        canMaintain: this.featureGuideCanMaintain,
        embedMode: this.featureGuideEmbedMode,
      });
    },
    /** roomType：无酒店时仍允许引导 toolbar */
    ebkRoomTypeHasHotelContext() {
      try {
        var raw = localStorage.getItem("chooseHotel");
        if (!raw) return false;
        var o = JSON.parse(raw);
        return !!(o && o.res_id != null);
      } catch (e) {
        return false;
      }
    },
  },
};

export { GUIDE_IDS };
export { getGuideIdForRoute } from "@/config/featureGuides";



// WEBPACK FOOTER //
// ./src/mixins/featureGuideMixin.js